export default __webpack_public_path__ + "static/media/blocked.7d4eb761.svg";